import { models } from '@kurtosys/ksys-app-template';
export const AUTHENTICATION: models.appsInitialize.IAppAuthentication = {
	token: 'f09e99df-de0c-456c-ac04-ceb6b39a005c',
	serviceUrl: 'https://api-rel.fundpress.io',
};